import Logs from "../";

const routes = [{ name: "LogsList", path: "/logs", component: Logs.LogsList, meta: { title: "System Logs - Home" } }];
export default routes;
